export const dataEmpresa = [
  {
    key: 1,
    label: "Humano Seguros",
    value: "30",
  },
  {
    key: 2,
    label: "Primera Ars",
    value: "96",
  },
];

export const dataRamos = [
  {
    key: 1,
    label: "Salud Local",
    value: "95",
  },
  {
    key: 2,
    label: "Salud Internacional",
    value: "93",
  },
  {
    key: 3,
    label: "Plan Básico de Salud",
    value: "94",
  },
];

export const dataTipoNCF = [
  {
    key: 1,
    label: "FACTURA",
    value: "F",
  },
  {
    key: 2,
    label: "CREDITO",
    value: "C",
  },
];

export const dataTipoServicio = [
  {
    key: 1,
    label: "Ambulatorio",
    value: "1",
  },
  {
    key: 2,
    label: "Emergencia",
    value: "3",
  },
  {
    key: 3,
    label: "Odontología",
    value: "8",
  },
  {
    key: 4,
    label: "Diálisis",
    value: "71",
  },
  {
    key: 5,
    label: "Quimioterapia",
    value: "72",
  },
  {
    key: 6,
    label: "Radioterapia",
    value: "73",
  },
  {
    key: 7,
    label: "Servicio Cero Trámite",
    value: "32",
  },
];

export const dataTipoServicioPyp = [
  {
    key: 4,
    label: "Promoción y Prevención",
    value: "6",
  },
];

export const dataArl = [
  {
    key: 1,
    label: "No es ARL",
    value: "No",
  },
  {
    key: 2,
    label: "Si es ARL",
    value: "Si",
  },
];

export const dataTipoServicioTodos = [
  {
    key: 1,
    label: "Ambulatorio",
    value: "1",
  },
  {
    key: 2,
    label: "Emergencia",
    value: "3",
  },
  {
    key: 3,
    label: "Odontología",
    value: "8",
  },
  {
    key: 4,
    label: "Promoción y Prevención",
    value: "6",
  },
  {
    key: 5,
    label: "Gasto Médico Mayor",
    value: "65",
  },
  {
    key: 6,
    label: "Alto Costo",
    value: "13",
  },
  {
    key: 7,
    label: "Servicio Cero Trámite",
    value: "32",
  },
];

export const dataTipoTelefono = [
  {
    key: 1,
    label: "Célular",
    value: "CEL",
  },
  {
    key: 2,
    label: "Casa",
    value: "RES",
  },
  {
    key: 3,
    label: "Trabajo",
    value: "TRA",
  },
];

export const dataFisicoRequerido = [
  {
    key: 1,
    label: "No",
    value: "No",
  },
  {
    key: 2,
    label: "Si",
    value: "Si",
  },
];

export const ESTATUS_FIRMA = [
  {
    key: 1,
    label: "Firma Electrónica Requerida",
    value: "FE",
  },
  {
    key: 2,
    label: "Vía WhatsApp",
    value: "WA",
  },
  {
    key: 3,
    label: "Vía Correo",
    value: "CR",
  },
  {
    key: 4,
    label: "Firma Biométrica",
    value: "BM",
  },
  {
    key: 5,
    label: "No Requiere Firma",
    value: "NF",
  },
  {
    key: 6,
    label: "Firma Física",
    value: "FF",
  },
];

export const DIAGNOSTICO_DEFINITIVO = [
  {
    key: 1,
    label: "Si",
    value: "S",
  },
  {
    key: 2,
    label: "No",
    value: "N",
  },
];

export const PRIMERA_CONSULTA = [
  {
    key: 1,
    label: "Primera vez",
    value: "S",
  },
  {
    key: 2,
    label: "Consulta de seguimiento",
    value: "N",
  },
];

export const TIPO_DOCUMENTO_CORE = {
  PLASTICO: "PLASTICO",
  CEDULA: "CEDULA",
  PASAPORTE: "PASAPORTE",
  NUI: "NUI",
};

export const MAXIMO_CARATERES_DOCUMENTO = {
  CEDULA: 11,
  DEFAULT: 100,
};

export const TIPO_DOCUMENTO_OPTIONS = [
  {
    key: 1,
    label: "Cédula",
    value: "CEDULA",
  },
  {
    key: 2,
    label: "Pasaporte",
    value: "PASAPORTE",
  },
  {
    key: 3,
    label: "NUI",
    value: "NUI",
  },
];

export const dataTipoServicioCeroTramite = [
  {
    key: 1,
    label: "Servicio Cero Trámite",
    value: "32",
  },
];

export const dataTipoServicioCc = [
  {
    key: 4,
    label: "Crónicos Complejos",
    value: "27",
  },
];

export const optionsTipoServicioMap = {
  ct: dataTipoServicioCeroTramite,
  pyp: dataTipoServicioPyp,
  cc: dataTipoServicioCc,
  default: dataTipoServicio,
};

export const dataTipoServicioCierreCuentas = [
  {
    key: 1,
    label: "Ambulatorio",
    value: "1",
  },
  {
    key: 2,
    label: "Hospitalización",
    value: "2",
  },
  {
    key: 5,
    label: "Maternidad",
    value: "5",
  },
  {
    key: 11,
    label: "Parto",
    value: "11",
  },
  {
    key: 12,
    label: "Cesárea",
    value: "12",
  },
];

export const dataMotivoEgreso = [
  {
    key: 1,
    label: "Fallecimiento",
    value: "F",
  },
  {
    key: 2,
    label: "Transferencia a otro centro",
    value: "T",
  },
  {
    key: 3,
    label: "Alta",
    value: "A",
  },
];

export const dataCausaInternamiento = [
  {
    key: 1,
    label: "Consulta",
    value: "Consulta",
  },
  {
    key: 2,
    label: "Emergencia",
    value: "Emergencia",
  },
];

export const dataTipoPss = [
  {
    key: 1,
    label: "No Médico",
    value: "NO_MEDICO",
  },
  {
    key: 2,
    label: "Médico",
    value: "MEDICO",
  },
];
